import { z } from 'zod';
import { copyRowLimitFor, type SecuritySettings } from './security';
import type { Role } from '../constants/rbac';

/** Доступ рекрутёров к Базе включается только отдельным решением администратора. */
export const baseAccessSettingsSchema = z.object({ enabled: z.boolean() }).strict();
export type BaseAccessSettings = z.infer<typeof baseAccessSettingsSchema>;
export const DEFAULT_BASE_ACCESS_SETTINGS: BaseAccessSettings = { enabled: false };
export const BASE_COPY_ROW_LIMIT = 1;

/** У Базы собственный предел; снятие общего ограничения его не отменяет. */
export function sheetCopyRowLimitFor(
  settings: SecuritySettings,
  role: Role,
  sheetCode: string,
): number | null {
  if (sheetCode === 'base' && role !== 'admin') return BASE_COPY_ROW_LIMIT;
  return copyRowLimitFor(settings, role);
}
